import { useState } from "react";
import { X } from "lucide-react";
import { api } from "../lib/api";

export default function ChangePasswordModal({ open, onClose, noPassword }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  if (!open) return null;

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    if (next.length < 6) return setError("Password must be at least 6 characters.");
    if (next !== confirm) return setError("Passwords don't match.");
    setStatus("sending");
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      setStatus("done");
      setTimeout(() => { onClose(); reset(); }, 1500);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong.");
      setStatus("error");
    }
  }
  function reset() {
    setCurrent(""); setNext(""); setConfirm(""); setStatus("idle"); setError("");
  }

  return (
    <div className="fixed inset-0 z-50 bg-[#0a0a0a]/60 flex items-center justify-center p-4" onClick={onClose} data-testid="change-password-modal">
      <div className="w-full max-w-md border border-[#0a0a0a] bg-[#ede8dc] p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-baseline justify-between mb-4">
          <h3 className="bm-headline text-2xl">Change password.</h3>
          <button onClick={onClose} className="text-neutral-500 hover:text-[#0a0a0a]" data-testid="change-password-close">
            <X size={16} />
          </button>
        </div>
        {status === "done" ? (
          <div className="border border-emerald-700 bg-emerald-50 p-4 text-sm" data-testid="change-password-done">
            Password updated.
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            {!noPassword && (
              <>
                <label className="bm-eyebrow text-neutral-500 block mb-1">Current password</label>
                <input
                  type="password"
                  required
                  value={current}
                  onChange={(e) => setCurrent(e.target.value)}
                  className="w-full border-b border-[#0a0a0a] bg-transparent py-2 mb-4 focus:outline-none"
                  data-testid="change-password-current"
                />
              </>
            )}
            <label className="bm-eyebrow text-neutral-500 block mb-1">New password</label>
            <input
              type="password"
              required
              value={next}
              onChange={(e) => setNext(e.target.value)}
              className="w-full border-b border-[#0a0a0a] bg-transparent py-2 mb-4 focus:outline-none"
              data-testid="change-password-new"
              placeholder="at least 6 characters"
            />
            <label className="bm-eyebrow text-neutral-500 block mb-1">Confirm new password</label>
            <input
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full border-b border-[#0a0a0a] bg-transparent py-2 mb-6 focus:outline-none"
              data-testid="change-password-confirm"
            />
            {error && <div className="text-sm text-[#c72c2c] mb-3" data-testid="change-password-error">{error}</div>}
            <button
              type="submit"
              disabled={status === "sending"}
              className="w-full bg-[#0a0a0a] text-[#f5f2eb] py-3 bm-eyebrow disabled:opacity-60"
              data-testid="change-password-submit"
            >
              {status === "sending" ? "Updating…" : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
